import ViewStrategyBotContainer from './view-strategy-bot-container';

export default ViewStrategyBotContainer;
